import { Switch } from 'antd';
import { AntSwitch } from './styles';

const RBHSwitch = AntSwitch(Switch);

export default RBHSwitch;
